'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class SiteFeatures {
  fetch() {
    return __async(this, null, function* () {
      const res = yield index.adapter.sitefeatures.fetch();
      return res.map((feature) => {
        var _a, _b;
        return __spreadProps(__spreadValues({}, feature), {
          roles: feature.roles || [],
          birthday: feature.birthday || false,
          onSiteMarketing: (_a = feature.onSiteMarketing) != null ? _a : true,
          noOnSiteMarketing: (_b = feature.noOnSiteMarketing) != null ? _b : true,
          affiliatesExcludes: feature.affiliatesExcludes || [],
          countriesExcludes: feature.countriesExcludes || [],
          rolesExcludes: feature.rolesExcludes || [],
          locationExcludes: feature.locationExcludes || [],
          platform: feature.platform || { mobile: true, desktop: true },
          depositCount: feature.depositCount || null
        });
      });
    });
  }
}
const sitefeatures = new SiteFeatures();

exports.sitefeatures = sitefeatures;
